export default class Address {
    label: string;
    line1: string | undefined;
    line2: string | undefined;
    city: string | undefined;
    state: string;
    zip: string;
    country: string;

    constructor(
        label: string,
        line1: string | undefined,
        line2: string | undefined,
        city: string | undefined,
        state: string,
        zip: string,
        country: string
    ) {
        this.label = label;
        this.line1 = line1;
        this.line2 = line2;
        this.city = city;
        this.state = state;
        this.zip = zip;
        this.country = country;
    }
}
